/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Description_CreateInputs */



/**
* | output |
* | --- |
* | "The first row becomes the column names. A CSV carries no type information, so every column is created as text — change a type afterwards from the table's sch..." |
*
* @param {Datasets_Import_Csv_Description_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_description_create = /** @type {((inputs?: Datasets_Import_Csv_Description_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Description_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die erste Zeile wird zu den Spaltennamen. Eine CSV-Datei enthält keine Typinformationen, daher wird jede Spalte als Text angelegt — den Typ können Sie anschließend im Schema der Tabelle ändern.")
	return /** @type {LocalizedString} */ ("The first row becomes the column names. A CSV carries no type information, so every column is created as text — change a type afterwards from the table's schema.")
});